import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import StarIcon from '@mui/icons-material/Star';
import FavoriteIcon from '@mui/icons-material/Favorite';
import styles from './FavoritesPage.module.scss';

const FavoritesPage: React.FC = () => {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState('Todos');

  const categories = ['Todos', 'Restaurante', 'Café', 'Bar', 'Hamburgueria'];

  const establishments = [
    { id: 1, name: "Restaurante Alameda", category: "Restaurante", address: "Rua das Flores, 123", time: "11:00 - 23:00", rating: 4.8, distance: "500m", image: "https://placehold.co/100x100" },
    { id: 2, name: "Garagem Di Porto", category: "Bar", address: "Av. Paulista, 456", time: "18:00 - 02:00", rating: 4.6, distance: "1.2km", image: "https://placehold.co/100x100" },
    // Adicione os outros aqui...
  ];

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.headerTop}>
          <button onClick={() => navigate(-1)} className={styles.backBtn}>
            <ArrowBackIcon />
          </button>
          <div className={styles.titleInfo}>
            <h1>Todos os Favoritos</h1>
            <span>{establishments.length} estabelecimentos</span>
          </div>
          <FilterListIcon className={styles.filterIcon} />
        </div>

        <div className={styles.searchBar}>
          <SearchIcon />
          <input type="text" placeholder="Buscar estabelecimentos..." />
        </div>

        <div className={styles.filters}>
          {categories.map(cat => (
            <button 
              key={cat} 
              className={activeFilter === cat ? styles.activeFilter : ''}
              onClick={() => setActiveFilter(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      </header>

      <main className={styles.list}>
        {establishments.map(place => (
          <div key={place.id} className={styles.horizontalCard}>
            <div className={styles.imageWrapper}>
              <img src={place.image} alt={place.name} />
              <div className={styles.heartBadge}><FavoriteIcon fontSize="small" /></div>
            </div>
            
            <div className={styles.info}>
              <div className={styles.mainDetails}>
                <h3>{place.name}</h3>
                <span className={styles.categoryLabel}>{place.category}</span>
                <p>{place.address}</p>
                <p className={styles.time}>{place.time}</p>
              </div>
              
              <div className={styles.stats}>
                <div className={styles.rating}>
                  <StarIcon fontSize="inherit" /> {place.rating}
                </div>
                <div className={styles.distance}>{place.distance}</div>
              </div>
            </div>
          </div>
        ))}
      </main>
    </div>
  );
};

export default FavoritesPage;